
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ArtistSection from './components/ArtistSection';
import PortfolioSection from './components/PortfolioSection';
import UrbanArtSection from './components/UrbanArtSection';
import ReviewsSection from './components/ReviewsSection';
import BookingSection from './components/BookingSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-neutral-900">
      <Navbar />
      <main>
        <HeroSection />
        <ArtistSection />
        <PortfolioSection />
        <UrbanArtSection />
        <ReviewsSection />
        <BookingSection />
        <FAQSection />
        <FeaturesSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
